import React, { Fragment, useState, useContext, useCallback } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";
import debounce from "lodash.debounce";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  Save,
  PersonOutline,
  MailOutline,
  WhatsApp,
  PercentOutlined,
} from "@mui/icons-material";
import {
  DialogContent,
  Grid,
  Snackbar,
  TextField,
  Slide,
  FormControl,
  Alert,
  Dialog,
} from "@mui/material";

import LoadStates from "components/services/LoadStates";
import LoadCities from "components/services/LoadCities";
import imgLoader from "assets/img/loading.gif";
import LoadGender from "components/services/LoadGender";
import LoadProfile from "components/services/LoadProfile";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewCompanyAdmin(props) {
  const classes = useStyles();

  const [loaders, setLoaders] = useState(false);
  const [disabledCities, setDisabledCities] = useState(true);
  const [error, setError] = useState("");
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = useState(false);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    document_id: "",
    name: "",
    email: "",
    phone: "",
    states: "",
    statesData: "",
    cities: "",
    citiesData: "",
    direccion: "",
    nameContact: "",
    lastNameContact: "",
    document_idContact: "",
    emailContact: "",
    gender: "",
    genderData: "",
    profile: 2,
    profileData: { id: 2, name: "Administrador" },
    percentage: "",
    errorDocument: false,
    errorName: false,
    errorEmail: false,
    errorPhone: false,
    errorStates: false,
    errorCities: false,
    errorDireccion: false,
    errorNameContact: false,
    errorLastNameContact: false,
    errorDocument_idContact: false,
    errorEmailContact: false,
    errorGender: false,
    errorProfile: false,
    errorPercentage: false,
  });

  const handleChange = (prop) => (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: event.target.value,
      errorName: false,
      errorDocument: false,
      errorEmail: false,
      errorPhone: false,
      errorDireccion: false,
      errorPercentage: false,
      errorNameContact: false,
      errorLastNameContact: false,
      errorDocument_idContact: false,
      errorEmailContact: false,
      errorGender: false,
      errorProfile: false,
    }));

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);

    if (values.document_id.length === 0) {
      setValues({ ...values, errorDocument: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Nro. Ruc" es obligatorio.',
      });
    } else if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Nombre" es obligatorio.',
      });
    } else if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Correo Electrónico" es obligatorio.',
      });
    } else if (values.states === "") {
      setValues({ ...values, errorStates: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Provincias" es obligatorio.',
      });
    } else if (values.cities === "") {
      setValues({ ...values, errorCities: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Ciudad" es obligatorio.',
      });
    } else if (values.direccion.length === 0) {
      setValues({ ...values, errorDireccion: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Dirección" es obligatorio.',
      });
    } else if (values.phone.length === 0) {
      setValues({ ...values, errorPhone: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Número de whatsapp" es obligatorio.',
      });
    } else if (values.nameContact.length === 0) {
      setValues({ ...values, errorNameContact: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Nombre de la persona de contacto" es obligatorio.',
      });
    } else if (values.lastNameContact.length === 0) {
      setValues({ ...values, errorLastNameContact: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje:
          'El campo "Apellidos de la persona de contacto" es obligatorio.',
      });
    } else if (values.document_idContact.length === 0) {
      setValues({ ...values, errorDocument_idContact: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje:
          'El campo "Documento de la persona de contacto" es obligatorio.',
      });
    } else if (values.emailContact.length === 0) {
      setValues({ ...values, errorEmailContact: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje:
          'El campo "Correo electrónico de la persona de contacto" es obligatorio.',
      });
    } else if (values.gender === "") {
      setValues({ ...values, errorGender: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Género de la persona de contacto" es obligatorio.',
      });
    } else if (values.profile === "") {
      setValues({ ...values, errorProfile: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: 'El campo "Perfil de la persona de contacto" es obligatorio.',
      });
    } else if (values.percentage === "") {
      setValues({ ...values, errorPercentage: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un porcentaje de ganacia.",
      });
    } else {
      const dataValue = {
        name: values.name,
        nRuc: values.document_id,
        provinceId: values.states,
        cityId: values.cities,
        direccion: values.direccion,
        email: values.email,
        phone: values.phone,
        percentage: values.percentage,
      };

      axios
        .post(`${urlServices}company`, dataValue, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
        .then((response) => {
          const userPromises = [];

          const randomNumber = Math.floor(Math.random() * 900000) + 100000;

          let valuesContact = {
            email: values.emailContact.toLowerCase().trim(),
            documentId: values.document_idContact,
            name: values.nameContact,
            lastName: values.lastNameContact,
            allNames: values.nameContact + " " + values.lastNameContact,
            genderId: values.gender,
            profileId: values.profile,
            password: randomNumber.toString(),
            companyId: response.data.company.id,
            status: 99,
          };

          userPromises.push(insertUsers(valuesContact, 1));

          // Esperar a que todas las promesas se resuelvan
          return Promise.all(userPromises);
        })
        .then((response) => {
          setValues({
            ...values,
            document_id: "",
            name: "",
            email: "",
            phone: "",
            states: "",
            statesData: "",
            cities: "",
            citiesData: "",
            direccion: "",
            nameContact: "",
            lastNameContact: "",
            document_idContact: "",
            emailContact: "",
            gender: "",
            genderData: "",
            profile: "",
            profileData: "",
            percentage: "",
          });

          setAlert({
            ...alert,
            openAlert: true,
            errorAlert: "success",
            mensaje: "Empresa registrada con éxito.",
          });
          setLoaders(false);

          props.callBackRefresh();
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setMensageSystem(
              "La sesión ha expirado, vuelva a iniciar sesión ..."
            );
            setError(true);

            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 4000);
          } else if (e.response.status === 500) {
            setMensageSystem("Error en la consulta con sel servidor.");
            setError(true);
          }
        });
    }
  };

  const insertUsers = (data, value) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${urlServices}users`, data, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
        .then((response) => {
          resolve(response); // Resolvemos la promesa con la respuesta de axios
        })
        .catch((error) => {
          //reject(error); // Rechazamos la promesa con el error de axios
          resolve(error);
        });
    });
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  const changeStates = (data) => {
    setValues({
      ...values,
      states: data !== null ? data.id : "",
      statesData: data !== null ? data : "",
      errorStates: false,
      cities: "",
      citiesData: "",
    });

    setDisabledCities(data !== null ? false : true);
    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const changeCities = (data) => {
    setValues({
      ...values,
      cities: data !== null ? data.id : "",
      citiesData: data !== null ? data : "",
      errorCities: false,
    });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender: data !== null ? data.id : "",
      genderData: data !== null ? data : "",
      errorGender: false,
    });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const changeProfile = (data) => {
    setValues({
      ...values,
      profile: data !== null ? data.id : "",
      profileData: data !== null ? data : "",
      errorProfile: false,
    });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        // onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                <div className={classes.titleCardFilter}>Nueva empresa</div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid
                  container
                  spacing={1}
                  style={{
                    backgroundColor: "rgb(248, 248, 248, 0.71)",
                    borderRadius: 5,
                    padding: 10,
                  }}
                >
                  <Grid item xs={12} sm={6}>
                    <span style={{ color: "#000", fontWeight: 500 }}>
                      Datos de la empresa:
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="document_id"
                        value={values.document_id}
                        error={values.errorDocument}
                        onChange={handleChange("document_id")}
                        fullWidth
                        // required
                        label="Nro. Ruc"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 13,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        style={{ background: "#FFFFFF" }}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      autoComplete="off"
                      name="name"
                      value={values.name}
                      onChange={handleChange("name")}
                      label="Nombre de la empresa"
                      error={values.errorName}
                      fullWidth
                      required
                      margin="dense"
                      variant="outlined"
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email"
                      value={values.email}
                      onChange={handleChange("email")}
                      label="Correo electrónico de la empresa"
                      error={values.errorEmail}
                      fullWidth
                      required
                      margin="dense"
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <MailOutline
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></MailOutline>
                        ),
                      }}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadStates
                      value={values.statesData}
                      refresh={changeStates}
                      idCountries={45}
                      error={values.errorStates}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="phone"
                      value={values.phone}
                      onChange={handleChange("phone")}
                      label="Número de Whatsapp"
                      fullWidth
                      required
                      InputProps={{
                        style: {
                          textAlign: "center",
                        },
                        endAdornment: (
                          <WhatsApp
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></WhatsApp>
                        ),
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      inputProps={{
                        maxLength: 12,
                      }}
                      margin="dense"
                      variant="outlined"
                      error={values.errorPhone}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadCities
                      value={values.citiesData}
                      refresh={changeCities}
                      disabled={disabledCities}
                      idStates={values.states}
                      error={values.errorCities}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="direccion"
                      value={values.direccion}
                      onChange={handleChange("direccion")}
                      label="Dirección de la empresa"
                      fullWidth
                      required
                      margin="dense"
                      variant="outlined"
                      error={values.errorDireccion}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <span style={{ color: "#000", fontWeight: 500 }}>
                      Configuración:{" "}
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <FormControl style={{ width: "70%" }}>
                      <TextField
                        name="percentage"
                        value={values.percentage}
                        onChange={handleChange("percentage")}
                        error={values.errorPercentage}
                        fullWidth
                        required
                        size="small"
                        label="Porcentaje"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 3,
                        }}
                        type="number"
                        InputProps={{
                          endAdornment: (
                            <PercentOutlined
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></PercentOutlined>
                          ),
                        }}
                        //  helperText="Si no se sabe el porcentaje de la comisión, colocar 0."
                      />
                      <Alert severity="info" sx={{ fontSize: 12 }}>
                        El porcentaje de ganancia de la empresa.
                      </Alert>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                    <span style={{ color: "#000", fontWeight: 500 }}>
                      Persona de contacto:{" "}
                    </span>
                    <span style={{ fontSize: 12, fontWeight: "400" }}>
                      (Se enviará a este usuario un correo de bienvenida y el
                      acceso al sistema.)
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="name"
                        value={values.nameContact}
                        error={values.errorNameContact}
                        onChange={handleChange("nameContact")}
                        fullWidth
                        required
                        label="Nombre"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <PersonOutline
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></PersonOutline>
                          ),
                        }}
                        style={{ background: "#FFFFFF" }}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="lastNameContact"
                        value={values.lastNameContact}
                        error={values.errorLastNameContact}
                        onChange={handleChange("lastNameContact")}
                        fullWidth
                        required
                        label="Apellidos"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <PersonOutline
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></PersonOutline>
                          ),
                        }}
                        style={{ background: "#FFFFFF" }}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="document_idContact"
                        value={values.document_idContact}
                        error={values.errorDocument_idContact}
                        onChange={handleChange("document_idContact")}
                        fullWidth
                        required
                        label="Documento"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 13,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        helperText="Cédula, RUC o pasaporte."
                        style={{ background: "#FFFFFF" }}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="emailContact"
                      value={values.emailContact}
                      onChange={handleChange("emailContact")}
                      label="Correo electrónico"
                      error={values.errorEmailContact}
                      InputProps={{
                        endAdornment: (
                          <MailOutline
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></MailOutline>
                        ),
                      }}
                      fullWidth
                      margin="dense"
                      size="small"
                      required
                      variant="outlined"
                      style={{ background: "#FFFFFF" }}
                      //helperText="Se enviará un correo de bienvenida y el acceso al sistema."
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadGender
                      value={values.genderData}
                      refresh={changeGender}
                      error={values.errorGender}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadProfile
                      value={values.profileData}
                      refresh={changeProfile}
                      error={values.errorProfile}
                      hide={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12}>
                {loaders ? (
                  <center>
                    <img
                      src={imgLoader}
                      alt="loader"
                      style={{
                        width: 60,
                        objectFit: "contain",
                        marginTop: 25,
                      }}
                    />
                  </center>
                ) : (
                  <div style={{ float: "right" }}>
                    <ButtonExit
                      className={classes.buttonLeft}
                      onClick={handleCloseDialog(true)}
                    >
                      Cerrar
                    </ButtonExit>
                    <ButtonStyle0 onClick={submitForm} endIcon={<Save />}>
                      Guardar
                    </ButtonStyle0>
                  </div>
                )}
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
